class Crumb {
  constructor(name, parent = null) {
    this.name = name;
    this.parent = parent;
  }

  addChild = (name) => {
    return new Crumb(name, this);
  };

  getName = () => this.name;

  getParent = () => this.parent;

  hasParent = () => this.parent !== null;
}

export default Crumb;
